/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-shadow */
import AbaBicOperationAck, { DefaultAbaBicOperationAck } from './AbaBicOperationAck/AbaBicOperationAck';
import AbaBicOperationRej, { DefaultAbaBicOperationRej } from './AbaBicOperationRej/AbaBicOperationRej';
import AbaBicOperationReq, { DefaultAbaBicOperationReq } from './AbaBicOperationReq/AbaBicOperationReq';
import AbaBicRecord, { DefaultAbaBicRecord } from './AbaBicRecord/AbaBicRecord';
import AbaFedOperationAck, { DefaultAbaFedOperationAck } from './AbaFedOperationAck/AbaFedOperationAck';
import AbaFedOperationRej, { DefaultAbaFedOperationRej } from './AbaFedOperationRej/AbaFedOperationRej';
import AbaFedOperationReq, { DefaultAbaFedOperationReq } from './AbaFedOperationReq/AbaFedOperationReq';
import AbaFedRecord, { DefaultAbaFedRecord } from './AbaFedRecord/AbaFedRecord';
import AccountRecord, { DefaultAccountRecord } from './AccountRecord/AccountRecord';
import AccountStatisticsReport, { DefaultAccountStatisticsReport } from './AccountStatisticsReport/AccountStatisticsReport';
import AccountWireDataRecord, { DefaultAccountWireDataRecord } from './AccountWireDataRecord/AccountWireDataRecord';
import Activity, { DefaultActivity } from './Activity/Activity';
import AddressBookRecord, { DefaultAddressBookRecord } from './AddressBookRecord/AddressBookRecord';
import AdminDepositExceptionReq, { DefaultAdminDepositExceptionReq } from './AdminDepositExceptionReq/AdminDepositExceptionReq';
import AdminExtRecvExceptionReq, { DefaultAdminExtRecvExceptionReq } from './AdminExtRecvExceptionReq/AdminExtRecvExceptionReq';
import AdminExtSendExceptionReq, { DefaultAdminExtSendExceptionReq } from './AdminExtSendExceptionReq/AdminExtSendExceptionReq';
import AdminRedeemExceptionReq, { DefaultAdminRedeemExceptionReq } from './AdminRedeemExceptionReq/AdminRedeemExceptionReq';
import Alert, { DefaultAlert } from './Alert/Alert';
import APIAddConnectionReq, { DefaultAPIAddConnectionReq } from './APIAddConnectionReq/APIAddConnectionReq';
import APIAddFirmConnectionReq, { DefaultAPIAddFirmConnectionReq } from './APIAddFirmConnectionReq/APIAddFirmConnectionReq';
import APIAddUserConnectionReq, { DefaultAPIAddUserConnectionReq } from './APIAddUserConnectionReq/APIAddUserConnectionReq';
import APIAdminAddConnectionRequest, { DefaultAPIAdminAddConnectionRequest } from './APIAdminAddConnectionRequest/APIAdminAddConnectionRequest';
import APIAdminAddUserConnectionRequest, { DefaultAPIAdminAddUserConnectionRequest } from './APIAdminAddUserConnectionRequest/APIAdminAddUserConnectionRequest';
import APIAdminDeleteApprovedAbaRequest, { DefaultAPIAdminDeleteApprovedAbaRequest } from './APIAdminDeleteApprovedAbaRequest/APIAdminDeleteApprovedAbaRequest';
import APIAdminDeleteBicAbaRequest, { DefaultAPIAdminDeleteBicAbaRequest } from './APIAdminDeleteBicAbaRequest/APIAdminDeleteBicAbaRequest';
import APIAdminDeleteConnectionRequest, { DefaultAPIAdminDeleteConnectionRequest } from './APIAdminDeleteConnectionRequest/APIAdminDeleteConnectionRequest';
import APIAdminDeleteUserConnectionRequest, { DefaultAPIAdminDeleteUserConnectionRequest } from './APIAdminDeleteUserConnectionRequest/APIAdminDeleteUserConnectionRequest';
import APIAdminDeleteUserRequest, { DefaultAPIAdminDeleteUserRequest } from './APIAdminDeleteUserRequest/APIAdminDeleteUserRequest';
import APIAdminModifyApprovedAbaRequest, { DefaultAPIAdminModifyApprovedAbaRequest } from './APIAdminModifyApprovedAbaRequest/APIAdminModifyApprovedAbaRequest';
import APIAdminModifyBicAbaRequest, { DefaultAPIAdminModifyBicAbaRequest } from './APIAdminModifyBicAbaRequest/APIAdminModifyBicAbaRequest';
import APIAdminModifyConnectionRequest, { DefaultAPIAdminModifyConnectionRequest } from './APIAdminModifyConnectionRequest/APIAdminModifyConnectionRequest';
import APIAdminModifyFirmConnectionRequest, { DefaultAPIAdminModifyFirmConnectionRequest } from './APIAdminModifyFirmConnectionRequest/APIAdminModifyFirmConnectionRequest';
import APIAdminModifyFirmWireDataRequest, { DefaultAPIAdminModifyFirmWireDataRequest } from './APIAdminModifyFirmWireDataRequest/APIAdminModifyFirmWireDataRequest';
import APIAdminModifyUserConnectionRequest, { DefaultAPIAdminModifyUserConnectionRequest } from './APIAdminModifyUserConnectionRequest/APIAdminModifyUserConnectionRequest';
import APIConnectionFirmsRecord, { DefaultAPIConnectionFirmsRecord } from './APIConnectionFirmsRecord/APIConnectionFirmsRecord';
import APIConnectionRecord, { DefaultAPIConnectionRecord } from './APIConnectionRecord/APIConnectionRecord';
import APIConnectionUsersRecord, { DefaultAPIConnectionUsersRecord } from './APIConnectionUsersRecord/APIConnectionUsersRecord';
import APIDeleteConnectionReq, { DefaultAPIDeleteConnectionReq } from './APIDeleteConnectionReq/APIDeleteConnectionReq';
import APIDeleteFirmConnectionReq, { DefaultAPIDeleteFirmConnectionReq } from './APIDeleteFirmConnectionReq/APIDeleteFirmConnectionReq';
import APIDeleteUserConnectionReq, { DefaultAPIDeleteUserConnectionReq } from './APIDeleteUserConnectionReq/APIDeleteUserConnectionReq';
import APIModifyConnectionReq, { DefaultAPIModifyConnectionReq } from './APIModifyConnectionReq/APIModifyConnectionReq';
import APIModifyFirmConnectionReq, { DefaultAPIModifyFirmConnectionReq } from './APIModifyFirmConnectionReq/APIModifyFirmConnectionReq';
import APIModifyUserConnectionReq, { DefaultAPIModifyUserConnectionReq } from './APIModifyUserConnectionReq/APIModifyUserConnectionReq';
import APITransaction, { DefaultAPITransaction } from './APITransaction/APITransaction';
import Bank2BankCreditProfile, { DefaultBank2BankCreditProfile } from './Bank2BankCreditProfile/Bank2BankCreditProfile';
import Bank2NetworkCreditProfile, { DefaultBank2NetworkCreditProfile } from './Bank2NetworkCreditProfile/Bank2NetworkCreditProfile';
import BankAPIAccountInquiryAck, { DefaultBankAPIAccountInquiryAck } from './BankAPIAccountInquiryAck/BankAPIAccountInquiryAck';
import BankAPIAccountInquiryRej, { DefaultBankAPIAccountInquiryRej } from './BankAPIAccountInquiryRej/BankAPIAccountInquiryRej';
import BankAPIAccountInquiryReq, { DefaultBankAPIAccountInquiryReq } from './BankAPIAccountInquiryReq/BankAPIAccountInquiryReq';
import BankCreditRiskLimitAck, { DefaultBankCreditRiskLimitAck } from './BankCreditRiskLimitAck/BankCreditRiskLimitAck';
import BankCreditRiskLimitRej, { DefaultBankCreditRiskLimitRej } from './BankCreditRiskLimitRej/BankCreditRiskLimitRej';
import BankCreditRiskLimitReq, { DefaultBankCreditRiskLimitReq } from './BankCreditRiskLimitReq/BankCreditRiskLimitReq';
import BankExposureLimitRecord, { DefaultBankExposureLimitRecord } from './BankExposureLimitRecord/BankExposureLimitRecord';
import BankLiquidityLimitRecord, { DefaultBankLiquidityLimitRecord } from './BankLiquidityLimitRecord/BankLiquidityLimitRecord';
import ClientMessageRecord, { DefaultClientMessageRecord } from './ClientMessageRecord/ClientMessageRecord';
import ClientMessageReq, { DefaultClientMessageReq } from './ClientMessageReq/ClientMessageReq';
import ClientRole, { DefaultClientRole } from './ClientRole/ClientRole';
import ContainerStatus, { DefaultContainerStatus } from './ContainerStatus/ContainerStatus';
import CounterPartyRiskLimitRecord, { DefaultCounterPartyRiskLimitRecord } from './CounterPartyRiskLimitRecord/CounterPartyRiskLimitRecord';
import Currency, { DefaultCurrency } from './Currency/Currency';
import CustomerAddAccountReq, { DefaultCustomerAddAccountReq } from './CustomerAddAccountReq/CustomerAddAccountReq';
import CustomerAddAccountWireDataReq, { DefaultCustomerAddAccountWireDataReq } from './CustomerAddAccountWireDataReq/CustomerAddAccountWireDataReq';
import CustomerAddAddressBookRecordReq, { DefaultCustomerAddAddressBookRecordReq } from './CustomerAddAddressBookRecordReq/CustomerAddAddressBookRecordReq';
import CustomerAddFirmAccountReq, { DefaultCustomerAddFirmAccountReq } from './CustomerAddFirmAccountReq/CustomerAddFirmAccountReq';
import CustomerAddFirmReq, { DefaultCustomerAddFirmReq } from './CustomerAddFirmReq/CustomerAddFirmReq';
import CustomerAddFirmWireDataReq, { DefaultCustomerAddFirmWireDataReq } from './CustomerAddFirmWireDataReq/CustomerAddFirmWireDataReq';
import CustomerAddPCGReq, { DefaultCustomerAddPCGReq } from './CustomerAddPCGReq/CustomerAddPCGReq';
import CustomerAddPCGUserReq, { DefaultCustomerAddPCGUserReq } from './CustomerAddPCGUserReq/CustomerAddPCGUserReq';
import CustomerAddUserAccountReq, { DefaultCustomerAddUserAccountReq } from './CustomerAddUserAccountReq/CustomerAddUserAccountReq';
import CustomerAddUserReq, { DefaultCustomerAddUserReq } from './CustomerAddUserReq/CustomerAddUserReq';
import CustomerAddUserRoleReq, { DefaultCustomerAddUserRoleReq } from './CustomerAddUserRoleReq/CustomerAddUserRoleReq';
import CustomerAddUserValidationReq, { DefaultCustomerAddUserValidationReq } from './CustomerAddUserValidationReq/CustomerAddUserValidationReq';
import CustomerAddWireAck, { DefaultCustomerAddWireAck } from './CustomerAddWireAck/CustomerAddWireAck';
import CustomerAddWireRej, { DefaultCustomerAddWireRej } from './CustomerAddWireRej/CustomerAddWireRej';
import CustomerAddWireReq, { DefaultCustomerAddWireReq } from './CustomerAddWireReq/CustomerAddWireReq';
import CustomerApprovalReq, { DefaultCustomerApprovalReq } from './CustomerApprovalReq/CustomerApprovalReq';
import CustomerApproveUserValidationReq, { DefaultCustomerApproveUserValidationReq } from './CustomerApproveUserValidationReq/CustomerApproveUserValidationReq';
import CustomerCounterPartyRiskLimitAck, { DefaultCustomerCounterPartyRiskLimitAck } from './CustomerCounterPartyRiskLimitAck/CustomerCounterPartyRiskLimitAck';
import CustomerCounterPartyRiskLimitRej, { DefaultCustomerCounterPartyRiskLimitRej } from './CustomerCounterPartyRiskLimitRej/CustomerCounterPartyRiskLimitRej';
import CustomerCounterPartyRiskLimitReq, { DefaultCustomerCounterPartyRiskLimitReq } from './CustomerCounterPartyRiskLimitReq/CustomerCounterPartyRiskLimitReq';
import CustomerDeleteAccountWireDataReq, { DefaultCustomerDeleteAccountWireDataReq } from './CustomerDeleteAccountWireDataReq/CustomerDeleteAccountWireDataReq';
import CustomerDeleteAddressBookRecordReq, { DefaultCustomerDeleteAddressBookRecordReq } from './CustomerDeleteAddressBookRecordReq/CustomerDeleteAddressBookRecordReq';
import CustomerDeleteFirmReq, { DefaultCustomerDeleteFirmReq } from './CustomerDeleteFirmReq/CustomerDeleteFirmReq';
import CustomerDeleteFirmWireDataReq, { DefaultCustomerDeleteFirmWireDataReq } from './CustomerDeleteFirmWireDataReq/CustomerDeleteFirmWireDataReq';
import CustomerDeletePCGReq, { DefaultCustomerDeletePCGReq } from './CustomerDeletePCGReq/CustomerDeletePCGReq';
import CustomerDeletePCGUserReq, { DefaultCustomerDeletePCGUserReq } from './CustomerDeletePCGUserReq/CustomerDeletePCGUserReq';
import CustomerDeleteUserAccountReq, { DefaultCustomerDeleteUserAccountReq } from './CustomerDeleteUserAccountReq/CustomerDeleteUserAccountReq';
import CustomerDeleteUserReq, { DefaultCustomerDeleteUserReq } from './CustomerDeleteUserReq/CustomerDeleteUserReq';
import CustomerDeleteUserRoleReq, { DefaultCustomerDeleteUserRoleReq } from './CustomerDeleteUserRoleReq/CustomerDeleteUserRoleReq';
import CustomerDeleteUserValidationReq, { DefaultCustomerDeleteUserValidationReq } from './CustomerDeleteUserValidationReq/CustomerDeleteUserValidationReq';
import CustomerDepositApprovalReq, { DefaultCustomerDepositApprovalReq } from './CustomerDepositApprovalReq/CustomerDepositApprovalReq';
import CustomerDepositReq, { DefaultCustomerDepositReq } from './CustomerDepositReq/CustomerDepositReq';
import CustomerExternalSendApprovalReq, { DefaultCustomerExternalSendApprovalReq } from './CustomerExternalSendApprovalReq/CustomerExternalSendApprovalReq';
import CustomerExtSendReq, { DefaultCustomerExtSendReq } from './CustomerExtSendReq/CustomerExtSendReq';
import CustomerHeartbeat, { DefaultCustomerHeartbeat } from './CustomerHeartbeat/CustomerHeartbeat';
import CustomerIBNBankTransactionLimitAck, { DefaultCustomerIBNBankTransactionLimitAck } from './CustomerIBNBankTransactionLimitAck/CustomerIBNBankTransactionLimitAck';
import CustomerIBNBankTransactionLimitRej, { DefaultCustomerIBNBankTransactionLimitRej } from './CustomerIBNBankTransactionLimitRej/CustomerIBNBankTransactionLimitRej';
import CustomerIBNBankTransactionLimitReq, { DefaultCustomerIBNBankTransactionLimitReq } from './CustomerIBNBankTransactionLimitReq/CustomerIBNBankTransactionLimitReq';
import CustomerLiquidityLimitAck, { DefaultCustomerLiquidityLimitAck } from './CustomerLiquidityLimitAck/CustomerLiquidityLimitAck';
import CustomerLiquidityLimitRej, { DefaultCustomerLiquidityLimitRej } from './CustomerLiquidityLimitRej/CustomerLiquidityLimitRej';
import CustomerLiquidityLimitReq, { DefaultCustomerLiquidityLimitReq } from './CustomerLiquidityLimitReq/CustomerLiquidityLimitReq';
import CustomerLogin, { DefaultCustomerLogin } from './CustomerLogin/CustomerLogin';
import CustomerLogout, { DefaultCustomerLogout } from './CustomerLogout/CustomerLogout';
import CustomerModifyAccountReq, { DefaultCustomerModifyAccountReq } from './CustomerModifyAccountReq/CustomerModifyAccountReq';
import CustomerModifyAccountWireDataReq, { DefaultCustomerModifyAccountWireDataReq } from './CustomerModifyAccountWireDataReq/CustomerModifyAccountWireDataReq';
import CustomerModifyAddressBookRecordReq, { DefaultCustomerModifyAddressBookRecordReq } from './CustomerModifyAddressBookRecordReq/CustomerModifyAddressBookRecordReq';
import CustomerModifyFirmAccountReq, { DefaultCustomerModifyFirmAccountReq } from './CustomerModifyFirmAccountReq/CustomerModifyFirmAccountReq';
import CustomerModifyFirmReq, { DefaultCustomerModifyFirmReq } from './CustomerModifyFirmReq/CustomerModifyFirmReq';
import CustomerModifyFirmWireDataReq, { DefaultCustomerModifyFirmWireDataReq } from './CustomerModifyFirmWireDataReq/CustomerModifyFirmWireDataReq';
import CustomerModifyPCGReq, { DefaultCustomerModifyPCGReq } from './CustomerModifyPCGReq/CustomerModifyPCGReq';
import CustomerModifySettlementAck, { DefaultCustomerModifySettlementAck } from './CustomerModifySettlementAck/CustomerModifySettlementAck';
import CustomerModifySettlementRej, { DefaultCustomerModifySettlementRej } from './CustomerModifySettlementRej/CustomerModifySettlementRej';
import CustomerModifySettlementReq, { DefaultCustomerModifySettlementReq } from './CustomerModifySettlementReq/CustomerModifySettlementReq';
import CustomerModifyUserAccountReq, { DefaultCustomerModifyUserAccountReq } from './CustomerModifyUserAccountReq/CustomerModifyUserAccountReq';
import CustomerModifyUserReq, { DefaultCustomerModifyUserReq } from './CustomerModifyUserReq/CustomerModifyUserReq';
import CustomerModifyUserRoleReq, { DefaultCustomerModifyUserRoleReq } from './CustomerModifyUserRoleReq/CustomerModifyUserRoleReq';
import CustomerModifyUserValidationReq, { DefaultCustomerModifyUserValidationReq } from './CustomerModifyUserValidationReq/CustomerModifyUserValidationReq';
import CustomerPendingDepositAck, { DefaultCustomerPendingDepositAck } from './CustomerPendingDepositAck/CustomerPendingDepositAck';
import CustomerPendingExtSendAck, { DefaultCustomerPendingExtSendAck } from './CustomerPendingExtSendAck/CustomerPendingExtSendAck';
import CustomerPendingRedeemAck, { DefaultCustomerPendingRedeemAck } from './CustomerPendingRedeemAck/CustomerPendingRedeemAck';
import CustomerPendingSendAck, { DefaultCustomerPendingSendAck } from './CustomerPendingSendAck/CustomerPendingSendAck';
import CustomerRedeemApprovalReq, { DefaultCustomerRedeemApprovalReq } from './CustomerRedeemApprovalReq/CustomerRedeemApprovalReq';
import CustomerRedeemReq, { DefaultCustomerRedeemReq } from './CustomerRedeemReq/CustomerRedeemReq';
import CustomerReject, { DefaultCustomerReject } from './CustomerReject/CustomerReject';
import CustomerSCPAck, { DefaultCustomerSCPAck } from './CustomerSCPAck/CustomerSCPAck';
import CustomerSCPApprovalAck, { DefaultCustomerSCPApprovalAck } from './CustomerSCPApprovalAck/CustomerSCPApprovalAck';
import CustomerSCPApprovalRej, { DefaultCustomerSCPApprovalRej } from './CustomerSCPApprovalRej/CustomerSCPApprovalRej';
import CustomerSCPApprovalReq, { DefaultCustomerSCPApprovalReq } from './CustomerSCPApprovalReq/CustomerSCPApprovalReq';
import CustomerSCPPendingAck, { DefaultCustomerSCPPendingAck } from './CustomerSCPPendingAck/CustomerSCPPendingAck';
import CustomerSCPPendingReviewAck, { DefaultCustomerSCPPendingReviewAck } from './CustomerSCPPendingReviewAck/CustomerSCPPendingReviewAck';
import CustomerSCPRej, { DefaultCustomerSCPRej } from './CustomerSCPRej/CustomerSCPRej';
import CustomerSCPReq, { DefaultCustomerSCPReq } from './CustomerSCPReq/CustomerSCPReq';
import CustomerSCPReviewAck, { DefaultCustomerSCPReviewAck } from './CustomerSCPReviewAck/CustomerSCPReviewAck';
import CustomerSCPReviewRej, { DefaultCustomerSCPReviewRej } from './CustomerSCPReviewRej/CustomerSCPReviewRej';
import CustomerSCPReviewReq, { DefaultCustomerSCPReviewReq } from './CustomerSCPReviewReq/CustomerSCPReviewReq';
import CustomerSendApprovalReq, { DefaultCustomerSendApprovalReq } from './CustomerSendApprovalReq/CustomerSendApprovalReq';
import CustomerSendReq, { DefaultCustomerSendReq } from './CustomerSendReq/CustomerSendReq';
import DINAPIClientCreditRiskSetupReject, { DefaultDINAPIClientCreditRiskSetupReject } from './DINAPIClientCreditRiskSetupReject/DINAPIClientCreditRiskSetupReject';
import DINAPIClientLiquiditySetupReject, { DefaultDINAPIClientLiquiditySetupReject } from './DINAPIClientLiquiditySetupReject/DINAPIClientLiquiditySetupReject';
import FirmRecord, { DefaultFirmRecord } from './FirmRecord/FirmRecord';
import FirmStatisticsReport, { DefaultFirmStatisticsReport } from './FirmStatisticsReport/FirmStatisticsReport';
import FirmWireDataRecord, { DefaultFirmWireDataRecord } from './FirmWireDataRecord/FirmWireDataRecord';
import HistoryAck, { DefaultHistoryAck } from './HistoryAck/HistoryAck';
import HistoryRej, { DefaultHistoryRej } from './HistoryRej/HistoryRej';
import HistoryRequest, { DefaultHistoryRequest } from './HistoryRequest/HistoryRequest';
import IBNBankTransactionLimitRecord, { DefaultIBNBankTransactionLimitRecord } from './IBNBankTransactionLimitRecord/IBNBankTransactionLimitRecord';
import IBNConnectionStatus, { DefaultIBNConnectionStatus } from './IBNConnectionStatus/IBNConnectionStatus';
import IBNTransactionLimitRecord, { DefaultIBNTransactionLimitRecord } from './IBNTransactionLimitRecord/IBNTransactionLimitRecord';
import NetworkExposureLimitRecord, { DefaultNetworkExposureLimitRecord } from './NetworkExposureLimitRecord/NetworkExposureLimitRecord';
import NetworkLiquidityLimitRecord, { DefaultNetworkLiquidityLimitRecord } from './NetworkLiquidityLimitRecord/NetworkLiquidityLimitRecord';
import PCGUser, { DefaultPCGUser } from './PCGUser/PCGUser';
import PrivateClientGroup, { DefaultPrivateClientGroup } from './PrivateClientGroup/PrivateClientGroup';
import RecipientWireBlacklistOperationAck, { DefaultRecipientWireBlacklistOperationAck } from './RecipientWireBlacklistOperationAck/RecipientWireBlacklistOperationAck';
import RecipientWireBlacklistOperationRej, { DefaultRecipientWireBlacklistOperationRej } from './RecipientWireBlacklistOperationRej/RecipientWireBlacklistOperationRej';
import RecipientWireBlacklistOperationReq, { DefaultRecipientWireBlacklistOperationReq } from './RecipientWireBlacklistOperationReq/RecipientWireBlacklistOperationReq';
import RecipientWireBlacklistRecord, { DefaultRecipientWireBlacklistRecord } from './RecipientWireBlacklistRecord/RecipientWireBlacklistRecord';
import RequestForPaymentExpireTime, { DefaultRequestForPaymentExpireTime } from './RequestForPaymentExpireTime/RequestForPaymentExpireTime';
import SCPContainerOption, { DefaultSCPContainerOption } from './SCPContainerOption/SCPContainerOption';
import SCPContainerRecord, { DefaultSCPContainerRecord } from './SCPContainerRecord/SCPContainerRecord';
import SCPContainerType, { DefaultSCPContainerType } from './SCPContainerType/SCPContainerType';
import SCPExecutionTime, { DefaultSCPExecutionTime } from './SCPExecutionTime/SCPExecutionTime';
import SCPFrequencyType, { DefaultSCPFrequencyType } from './SCPFrequencyType/SCPFrequencyType';
import SCPOperationType, { DefaultSCPOperationType } from './SCPOperationType/SCPOperationType';
import SettlementCycleStatus, { DefaultSettlementCycleStatus } from './SettlementCycleStatus/SettlementCycleStatus';
import SettlementInstruction, { DefaultSettlementInstruction } from './SettlementInstruction/SettlementInstruction';
import SmartContractExecuteTime, { DefaultSmartContractExecuteTime } from './SmartContractExecuteTime/SmartContractExecuteTime';
import SmartContractPayment, { DefaultSmartContractPayment } from './SmartContractPayment/SmartContractPayment';
import SmartContractPaymentType, { DefaultSmartContractPaymentType } from './SmartContractPaymentType/SmartContractPaymentType';
import SmartContractStatus, { DefaultSmartContractStatus } from './SmartContractStatus/SmartContractStatus';
import StatisticsReport, { DefaultStatisticsReport } from './StatisticsReport/StatisticsReport';
import SystemKillSwitch, { DefaultSystemKillSwitch } from './SystemKillSwitch/SystemKillSwitch';
import SystemSCPKillSwitch, { DefaultSystemSCPKillSwitch } from './SystemSCPKillSwitch/SystemSCPKillSwitch';
import SystemWireKillSwitch, { DefaultSystemWireKillSwitch } from './SystemWireKillSwitch/SystemWireKillSwitch';
import TotalTokenBalance, { DefaultTotalTokenBalance } from './TotalTokenBalance/TotalTokenBalance';
import Transaction, { DefaultTransaction } from './Transaction/Transaction';
import UserAccountRecord, { DefaultUserAccountRecord } from './UserAccountRecord/UserAccountRecord';
import UserRecord, { DefaultUserRecord } from './UserRecord/UserRecord';
import UserRole, { DefaultUserRole } from './UserRole/UserRole';
import UserValidationRecord, { DefaultUserValidationRecord } from './UserValidationRecord/UserValidationRecord';
import UserValidationStats, { DefaultUserValidationStats } from './UserValidationStats/UserValidationStats';
import WireRole, { DefaultWireRole } from './WireRole/WireRole';
import WireTransaction, { DefaultWireTransaction } from './WireTransaction/WireTransaction';
import WireTransactionRej, { DefaultWireTransactionRej } from './WireTransactionRej/WireTransactionRej';

type CoreMsg = AbaBicOperationAck |
    AbaBicOperationRej |
    AbaBicOperationReq |
    AbaBicRecord |
    AbaFedOperationAck |
    AbaFedOperationRej |
    AbaFedOperationReq |
    AbaFedRecord |
    AccountRecord |
    AccountStatisticsReport |
    AccountWireDataRecord |
    Activity |
    AddressBookRecord |
    AdminDepositExceptionReq |
    AdminExtRecvExceptionReq |
    AdminExtSendExceptionReq |
    AdminRedeemExceptionReq |
    Alert |
    APIAddConnectionReq |
    APIAddFirmConnectionReq |
    APIAddUserConnectionReq |
    APIAdminAddConnectionRequest |
    APIAdminAddUserConnectionRequest |
    APIAdminDeleteApprovedAbaRequest |
    APIAdminDeleteBicAbaRequest |
    APIAdminDeleteConnectionRequest |
    APIAdminDeleteUserConnectionRequest |
    APIAdminDeleteUserRequest |
    APIAdminModifyApprovedAbaRequest |
    APIAdminModifyBicAbaRequest |
    APIAdminModifyConnectionRequest |
    APIAdminModifyFirmConnectionRequest |
    APIAdminModifyFirmWireDataRequest |
    APIAdminModifyUserConnectionRequest |
    APIConnectionFirmsRecord |
    APIConnectionRecord |
    APIConnectionUsersRecord |
    APIDeleteConnectionReq |
    APIDeleteFirmConnectionReq |
    APIDeleteUserConnectionReq |
    APIModifyConnectionReq |
    APIModifyFirmConnectionReq |
    APIModifyUserConnectionReq |
    APITransaction |
    Bank2BankCreditProfile |
    Bank2NetworkCreditProfile |
    BankAPIAccountInquiryAck |
    BankAPIAccountInquiryRej |
    BankAPIAccountInquiryReq |
    BankCreditRiskLimitAck |
    BankCreditRiskLimitRej |
    BankCreditRiskLimitReq |
    BankExposureLimitRecord |
    BankLiquidityLimitRecord |
    ClientMessageRecord |
    ClientMessageReq |
    ClientRole |
    ContainerStatus |
    CounterPartyRiskLimitRecord |
    Currency |
    CustomerAddAccountReq |
    CustomerAddAccountWireDataReq |
    CustomerAddAddressBookRecordReq |
    CustomerAddFirmAccountReq |
    CustomerAddFirmReq |
    CustomerAddFirmWireDataReq |
    CustomerAddPCGReq |
    CustomerAddPCGUserReq |
    CustomerAddUserAccountReq |
    CustomerAddUserReq |
    CustomerAddUserRoleReq |
    CustomerAddUserValidationReq |
    CustomerAddWireAck |
    CustomerAddWireRej |
    CustomerAddWireReq |
    CustomerApprovalReq |
    CustomerApproveUserValidationReq |
    CustomerCounterPartyRiskLimitAck |
    CustomerCounterPartyRiskLimitRej |
    CustomerCounterPartyRiskLimitReq |
    CustomerDeleteAccountWireDataReq |
    CustomerDeleteAddressBookRecordReq |
    CustomerDeleteFirmReq |
    CustomerDeleteFirmWireDataReq |
    CustomerDeletePCGReq |
    CustomerDeletePCGUserReq |
    CustomerDeleteUserAccountReq |
    CustomerDeleteUserReq |
    CustomerDeleteUserRoleReq |
    CustomerDeleteUserValidationReq |
    CustomerDepositApprovalReq |
    CustomerDepositReq |
    CustomerExternalSendApprovalReq |
    CustomerExtSendReq |
    CustomerHeartbeat |
    CustomerIBNBankTransactionLimitAck |
    CustomerIBNBankTransactionLimitRej |
    CustomerIBNBankTransactionLimitReq |
    CustomerLiquidityLimitAck |
    CustomerLiquidityLimitRej |
    CustomerLiquidityLimitReq |
    CustomerLogin |
    CustomerLogout |
    CustomerModifyAccountReq |
    CustomerModifyAccountWireDataReq |
    CustomerModifyAddressBookRecordReq |
    CustomerModifyFirmAccountReq |
    CustomerModifyFirmReq |
    CustomerModifyFirmWireDataReq |
    CustomerModifyPCGReq |
    CustomerModifySettlementAck |
    CustomerModifySettlementRej |
    CustomerModifySettlementReq |
    CustomerModifyUserAccountReq |
    CustomerModifyUserReq |
    CustomerModifyUserRoleReq |
    CustomerModifyUserValidationReq |
    CustomerPendingDepositAck |
    CustomerPendingExtSendAck |
    CustomerPendingRedeemAck |
    CustomerPendingSendAck |
    CustomerRedeemApprovalReq |
    CustomerRedeemReq |
    CustomerReject |
    CustomerSCPAck |
    CustomerSCPApprovalAck |
    CustomerSCPApprovalRej |
    CustomerSCPApprovalReq |
    CustomerSCPPendingAck |
    CustomerSCPPendingReviewAck |
    CustomerSCPRej |
    CustomerSCPReq |
    CustomerSCPReviewAck |
    CustomerSCPReviewRej |
    CustomerSCPReviewReq |
    CustomerSendApprovalReq |
    CustomerSendReq |
    DINAPIClientCreditRiskSetupReject |
    DINAPIClientLiquiditySetupReject |
    FirmRecord |
    FirmStatisticsReport |
    FirmWireDataRecord |
    HistoryAck |
    HistoryRej |
    HistoryRequest |
    IBNBankTransactionLimitRecord |
    IBNConnectionStatus |
    IBNTransactionLimitRecord |
    NetworkExposureLimitRecord |
    NetworkLiquidityLimitRecord |
    PCGUser |
    PrivateClientGroup |
    RecipientWireBlacklistOperationAck |
    RecipientWireBlacklistOperationRej |
    RecipientWireBlacklistOperationReq |
    RecipientWireBlacklistRecord |
    RequestForPaymentExpireTime |
    SCPContainerOption |
    SCPContainerRecord |
    SCPContainerType |
    SCPExecutionTime |
    SCPFrequencyType |
    SCPOperationType |
    SettlementCycleStatus |
    SettlementInstruction |
    SmartContractExecuteTime |
    SmartContractPayment |
    SmartContractPaymentType |
    SmartContractStatus |
    StatisticsReport |
    SystemKillSwitch |
    SystemSCPKillSwitch |
    SystemWireKillSwitch |
    TotalTokenBalance |
    Transaction |
    UserAccountRecord |
    UserRecord |
    UserRole |
    UserValidationRecord |
    UserValidationStats |
    WireRole |
    WireTransaction |
    WireTransactionRej;

export enum CoreMsgTypes {
    AbaBicOperationAck = 'AbaBicOperationAck',
    AbaBicOperationRej = 'AbaBicOperationRej',
    AbaBicOperationReq = 'AbaBicOperationReq',
    AbaBicRecord = 'AbaBicRecord',
    AbaFedOperationAck = 'AbaFedOperationAck',
    AbaFedOperationRej = 'AbaFedOperationRej',
    AbaFedOperationReq = 'AbaFedOperationReq',
    AbaFedRecord = 'AbaFedRecord',
    AccountRecord = 'AccountRecord',
    AccountStatisticsReport = 'AccountStatisticsReport',
    AccountWireDataRecord = 'AccountWireDataRecord',
    Activity = 'Activity',
    AddressBookRecord = 'AddressBookRecord',
    AdminDepositExceptionReq = 'AdminDepositExceptionReq',
    AdminExtRecvExceptionReq = 'AdminExtRecvExceptionReq',
    AdminExtSendExceptionReq = 'AdminExtSendExceptionReq',
    AdminRedeemExceptionReq = 'AdminRedeemExceptionReq',
    Alert = 'Alert',
    APIAddConnectionReq = 'APIAddConnectionReq',
    APIAddFirmConnectionReq = 'APIAddFirmConnectionReq',
    APIAddUserConnectionReq = 'APIAddUserConnectionReq',
    APIAdminAddConnectionRequest = 'APIAdminAddConnectionRequest',
    APIAdminAddUserConnectionRequest = 'APIAdminAddUserConnectionRequest',
    APIAdminDeleteApprovedAbaRequest = 'APIAdminDeleteApprovedAbaRequest',
    APIAdminDeleteBicAbaRequest = 'APIAdminDeleteBicAbaRequest',
    APIAdminDeleteConnectionRequest = 'APIAdminDeleteConnectionRequest',
    APIAdminDeleteUserConnectionRequest = 'APIAdminDeleteUserConnectionRequest',
    APIAdminDeleteUserRequest = 'APIAdminDeleteUserRequest',
    APIAdminModifyApprovedAbaRequest = 'APIAdminModifyApprovedAbaRequest',
    APIAdminModifyBicAbaRequest = 'APIAdminModifyBicAbaRequest',
    APIAdminModifyConnectionRequest = 'APIAdminModifyConnectionRequest',
    APIAdminModifyFirmConnectionRequest = 'APIAdminModifyFirmConnectionRequest',
    APIAdminModifyFirmWireDataRequest = 'APIAdminModifyFirmWireDataRequest',
    APIAdminModifyUserConnectionRequest = 'APIAdminModifyUserConnectionRequest',
    APIConnectionFirmsRecord = 'APIConnectionFirmsRecord',
    APIConnectionRecord = 'APIConnectionRecord',
    APIConnectionUsersRecord = 'APIConnectionUsersRecord',
    APIDeleteConnectionReq = 'APIDeleteConnectionReq',
    APIDeleteFirmConnectionReq = 'APIDeleteFirmConnectionReq',
    APIDeleteUserConnectionReq = 'APIDeleteUserConnectionReq',
    APIModifyConnectionReq = 'APIModifyConnectionReq',
    APIModifyFirmConnectionReq = 'APIModifyFirmConnectionReq',
    APIModifyUserConnectionReq = 'APIModifyUserConnectionReq',
    APITransaction = 'APITransaction',
    Bank2BankCreditProfile = 'Bank2BankCreditProfile',
    Bank2NetworkCreditProfile = 'Bank2NetworkCreditProfile',
    BankAPIAccountInquiryAck = 'BankAPIAccountInquiryAck',
    BankAPIAccountInquiryRej = 'BankAPIAccountInquiryRej',
    BankAPIAccountInquiryReq = 'BankAPIAccountInquiryReq',
    BankCreditRiskLimitAck = 'BankCreditRiskLimitAck',
    BankCreditRiskLimitRej = 'BankCreditRiskLimitRej',
    BankCreditRiskLimitReq = 'BankCreditRiskLimitReq',
    BankExposureLimitRecord = 'BankExposureLimitRecord',
    BankLiquidityLimitRecord = 'BankLiquidityLimitRecord',
    ClientMessageRecord = 'ClientMessageRecord',
    ClientMessageReq = 'ClientMessageReq',
    ClientRole = 'ClientRole',
    ContainerStatus = 'ContainerStatus',
    CounterPartyRiskLimitRecord = 'CounterPartyRiskLimitRecord',
    Currency = 'Currency',
    CustomerAddAccountReq = 'CustomerAddAccountReq',
    CustomerAddAccountWireDataReq = 'CustomerAddAccountWireDataReq',
    CustomerAddAddressBookRecordReq = 'CustomerAddAddressBookRecordReq',
    CustomerAddFirmAccountReq = 'CustomerAddFirmAccountReq',
    CustomerAddFirmReq = 'CustomerAddFirmReq',
    CustomerAddFirmWireDataReq = 'CustomerAddFirmWireDataReq',
    CustomerAddPCGReq = 'CustomerAddPCGReq',
    CustomerAddPCGUserReq = 'CustomerAddPCGUserReq',
    CustomerAddUserAccountReq = 'CustomerAddUserAccountReq',
    CustomerAddUserReq = 'CustomerAddUserReq',
    CustomerAddUserRoleReq = 'CustomerAddUserRoleReq',
    CustomerAddUserValidationReq = 'CustomerAddUserValidationReq',
    CustomerAddWireAck = 'CustomerAddWireAck',
    CustomerAddWireRej = 'CustomerAddWireRej',
    CustomerAddWireReq = 'CustomerAddWireReq',
    CustomerApprovalReq = 'CustomerApprovalReq',
    CustomerApproveUserValidationReq = 'CustomerApproveUserValidationReq',
    CustomerCounterPartyRiskLimitAck = 'CustomerCounterPartyRiskLimitAck',
    CustomerCounterPartyRiskLimitRej = 'CustomerCounterPartyRiskLimitRej',
    CustomerCounterPartyRiskLimitReq = 'CustomerCounterPartyRiskLimitReq',
    CustomerDeleteAccountWireDataReq = 'CustomerDeleteAccountWireDataReq',
    CustomerDeleteAddressBookRecordReq = 'CustomerDeleteAddressBookRecordReq',
    CustomerDeleteFirmReq = 'CustomerDeleteFirmReq',
    CustomerDeleteFirmWireDataReq = 'CustomerDeleteFirmWireDataReq',
    CustomerDeletePCGReq = 'CustomerDeletePCGReq',
    CustomerDeletePCGUserReq = 'CustomerDeletePCGUserReq',
    CustomerDeleteUserAccountReq = 'CustomerDeleteUserAccountReq',
    CustomerDeleteUserReq = 'CustomerDeleteUserReq',
    CustomerDeleteUserRoleReq = 'CustomerDeleteUserRoleReq',
    CustomerDeleteUserValidationReq = 'CustomerDeleteUserValidationReq',
    CustomerDepositApprovalReq = 'CustomerDepositApprovalReq',
    CustomerDepositReq = 'CustomerDepositReq',
    CustomerExternalSendApprovalReq = 'CustomerExternalSendApprovalReq',
    CustomerExtSendReq = 'CustomerExtSendReq',
    CustomerHeartbeat = 'CustomerHeartbeat',
    CustomerIBNBankTransactionLimitAck = 'CustomerIBNBankTransactionLimitAck',
    CustomerIBNBankTransactionLimitRej = 'CustomerIBNBankTransactionLimitRej',
    CustomerIBNBankTransactionLimitReq = 'CustomerIBNBankTransactionLimitReq',
    CustomerLiquidityLimitAck = 'CustomerLiquidityLimitAck',
    CustomerLiquidityLimitRej = 'CustomerLiquidityLimitRej',
    CustomerLiquidityLimitReq = 'CustomerLiquidityLimitReq',
    CustomerLogin = 'CustomerLogin',
    CustomerLogout = 'CustomerLogout',
    CustomerModifyAccountReq = 'CustomerModifyAccountReq',
    CustomerModifyAccountWireDataReq = 'CustomerModifyAccountWireDataReq',
    CustomerModifyAddressBookRecordReq = 'CustomerModifyAddressBookRecordReq',
    CustomerModifyFirmAccountReq = 'CustomerModifyFirmAccountReq',
    CustomerModifyFirmReq = 'CustomerModifyFirmReq',
    CustomerModifyFirmWireDataReq = 'CustomerModifyFirmWireDataReq',
    CustomerModifyPCGReq = 'CustomerModifyPCGReq',
    CustomerModifySettlementAck = 'CustomerModifySettlementAck',
    CustomerModifySettlementRej = 'CustomerModifySettlementRej',
    CustomerModifySettlementReq = 'CustomerModifySettlementReq',
    CustomerModifyUserAccountReq = 'CustomerModifyUserAccountReq',
    CustomerModifyUserReq = 'CustomerModifyUserReq',
    CustomerModifyUserRoleReq = 'CustomerModifyUserRoleReq',
    CustomerModifyUserValidationReq = 'CustomerModifyUserValidationReq',
    CustomerPendingDepositAck = 'CustomerPendingDepositAck',
    CustomerPendingExtSendAck = 'CustomerPendingExtSendAck',
    CustomerPendingRedeemAck = 'CustomerPendingRedeemAck',
    CustomerPendingSendAck = 'CustomerPendingSendAck',
    CustomerRedeemApprovalReq = 'CustomerRedeemApprovalReq',
    CustomerRedeemReq = 'CustomerRedeemReq',
    CustomerReject = 'CustomerReject',
    CustomerSCPAck = 'CustomerSCPAck',
    CustomerSCPApprovalAck = 'CustomerSCPApprovalAck',
    CustomerSCPApprovalRej = 'CustomerSCPApprovalRej',
    CustomerSCPApprovalReq = 'CustomerSCPApprovalReq',
    CustomerSCPPendingAck = 'CustomerSCPPendingAck',
    CustomerSCPPendingReviewAck = 'CustomerSCPPendingReviewAck',
    CustomerSCPRej = 'CustomerSCPRej',
    CustomerSCPReq = 'CustomerSCPReq',
    CustomerSCPReviewAck = 'CustomerSCPReviewAck',
    CustomerSCPReviewRej = 'CustomerSCPReviewRej',
    CustomerSCPReviewReq = 'CustomerSCPReviewReq',
    CustomerSendApprovalReq = 'CustomerSendApprovalReq',
    CustomerSendReq = 'CustomerSendReq',
    CustomerFxSendReq = 'CustomerFxSendReq',
    DINAPIClientCreditRiskSetupReject = 'DINAPIClientCreditRiskSetupReject',
    DINAPIClientLiquiditySetupReject = 'DINAPIClientLiquiditySetupReject',
    FirmRecord = 'FirmRecord',
    FirmStatisticsReport = 'FirmStatisticsReport',
    FirmWireDataRecord = 'FirmWireDataRecord',
    HistoryAck = 'HistoryAck',
    HistoryRej = 'HistoryRej',
    HistoryRequest = 'HistoryRequest',
    IBNBankTransactionLimitRecord = 'IBNBankTransactionLimitRecord',
    IBNConnectionStatus = 'IBNConnectionStatus',
    IBNTransactionLimitRecord = 'IBNTransactionLimitRecord',
    NetworkExposureLimitRecord = 'NetworkExposureLimitRecord',
    NetworkLiquidityLimitRecord = 'NetworkLiquidityLimitRecord',
    PCGUser = 'PCGUser',
    PrivateClientGroup = 'PrivateClientGroup',
    RecipientWireBlacklistOperationAck = 'RecipientWireBlacklistOperationAck',
    RecipientWireBlacklistOperationRej = 'RecipientWireBlacklistOperationRej',
    RecipientWireBlacklistOperationReq = 'RecipientWireBlacklistOperationReq',
    RecipientWireBlacklistRecord = 'RecipientWireBlacklistRecord',
    RequestForPaymentExpireTime = 'RequestForPaymentExpireTime',
    SCPContainerOption = 'SCPContainerOption',
    SCPContainerRecord = 'SCPContainerRecord',
    SCPContainerType = 'SCPContainerType',
    SCPExecutionTime = 'SCPExecutionTime',
    SCPFrequencyType = 'SCPFrequencyType',
    SCPOperationType = 'SCPOperationType',
    SettlementCycleStatus = 'SettlementCycleStatus',
    SettlementInstruction = 'SettlementInstruction',
    SmartContractExecuteTime = 'SmartContractExecuteTime',
    SmartContractPayment = 'SmartContractPayment',
    SmartContractPaymentType = 'SmartContractPaymentType',
    SmartContractStatus = 'SmartContractStatus',
    StatisticsReport = 'StatisticsReport',
    SystemKillSwitch = 'SystemKillSwitch',
    SystemSCPKillSwitch = 'SystemSCPKillSwitch',
    SystemWireKillSwitch = 'SystemWireKillSwitch',
    TotalTokenBalance = 'TotalTokenBalance',
    Transaction = 'Transaction',
    UserAccountRecord = 'UserAccountRecord',
    UserRecord = 'UserRecord',
    UserRole = 'UserRole',
    UserValidationRecord = 'UserValidationRecord',
    UserValidationStats = 'UserValidationStats',
    WireRole = 'WireRole',
    WireTransaction = 'WireTransaction',
    WireTransactionRej = 'WireTransactionRej'
}

export type {
    AbaBicOperationAck,
    AbaBicOperationRej,
    AbaBicOperationReq,
    AbaBicRecord,
    AbaFedOperationAck,
    AbaFedOperationRej,
    AbaFedOperationReq,
    AbaFedRecord,
    AccountRecord,
    AccountStatisticsReport,
    AccountWireDataRecord,
    Activity,
    AddressBookRecord,
    AdminDepositExceptionReq,
    AdminExtRecvExceptionReq,
    AdminExtSendExceptionReq,
    AdminRedeemExceptionReq,
    Alert,
    APIAddConnectionReq,
    APIAddFirmConnectionReq,
    APIAddUserConnectionReq,
    APIAdminAddConnectionRequest,
    APIAdminAddUserConnectionRequest,
    APIAdminDeleteApprovedAbaRequest,
    APIAdminDeleteBicAbaRequest,
    APIAdminDeleteConnectionRequest,
    APIAdminDeleteUserConnectionRequest,
    APIAdminDeleteUserRequest,
    APIAdminModifyApprovedAbaRequest,
    APIAdminModifyBicAbaRequest,
    APIAdminModifyConnectionRequest,
    APIAdminModifyFirmConnectionRequest,
    APIAdminModifyFirmWireDataRequest,
    APIAdminModifyUserConnectionRequest,
    APIConnectionFirmsRecord,
    APIConnectionRecord,
    APIConnectionUsersRecord,
    APIDeleteConnectionReq,
    APIDeleteFirmConnectionReq,
    APIDeleteUserConnectionReq,
    APIModifyConnectionReq,
    APIModifyFirmConnectionReq,
    APIModifyUserConnectionReq,
    APITransaction,
    Bank2BankCreditProfile,
    Bank2NetworkCreditProfile,
    BankAPIAccountInquiryAck,
    BankAPIAccountInquiryRej,
    BankAPIAccountInquiryReq,
    BankCreditRiskLimitAck,
    BankCreditRiskLimitRej,
    BankCreditRiskLimitReq,
    BankExposureLimitRecord,
    BankLiquidityLimitRecord,
    ClientMessageRecord,
    ClientMessageReq,
    ClientRole,
    ContainerStatus,
    CounterPartyRiskLimitRecord,
    Currency,
    CustomerAddAccountReq,
    CustomerAddAccountWireDataReq,
    CustomerAddAddressBookRecordReq,
    CustomerAddFirmAccountReq,
    CustomerAddFirmReq,
    CustomerAddFirmWireDataReq,
    CustomerAddPCGReq,
    CustomerAddPCGUserReq,
    CustomerAddUserAccountReq,
    CustomerAddUserReq,
    CustomerAddUserRoleReq,
    CustomerAddUserValidationReq,
    CustomerAddWireAck,
    CustomerAddWireRej,
    CustomerAddWireReq,
    CustomerApprovalReq,
    CustomerApproveUserValidationReq,
    CustomerCounterPartyRiskLimitAck,
    CustomerCounterPartyRiskLimitRej,
    CustomerCounterPartyRiskLimitReq,
    CustomerDeleteAccountWireDataReq,
    CustomerDeleteAddressBookRecordReq,
    CustomerDeleteFirmReq,
    CustomerDeleteFirmWireDataReq,
    CustomerDeletePCGReq,
    CustomerDeletePCGUserReq,
    CustomerDeleteUserAccountReq,
    CustomerDeleteUserReq,
    CustomerDeleteUserRoleReq,
    CustomerDeleteUserValidationReq,
    CustomerDepositApprovalReq,
    CustomerDepositReq,
    CustomerExternalSendApprovalReq,
    CustomerExtSendReq,
    CustomerHeartbeat,
    CustomerIBNBankTransactionLimitAck,
    CustomerIBNBankTransactionLimitRej,
    CustomerIBNBankTransactionLimitReq,
    CustomerLiquidityLimitAck,
    CustomerLiquidityLimitRej,
    CustomerLiquidityLimitReq,
    CustomerLogin,
    CustomerLogout,
    CustomerModifyAccountReq,
    CustomerModifyAccountWireDataReq,
    CustomerModifyAddressBookRecordReq,
    CustomerModifyFirmAccountReq,
    CustomerModifyFirmReq,
    CustomerModifyFirmWireDataReq,
    CustomerModifyPCGReq,
    CustomerModifySettlementAck,
    CustomerModifySettlementRej,
    CustomerModifySettlementReq,
    CustomerModifyUserAccountReq,
    CustomerModifyUserReq,
    CustomerModifyUserRoleReq,
    CustomerModifyUserValidationReq,
    CustomerPendingDepositAck,
    CustomerPendingExtSendAck,
    CustomerPendingRedeemAck,
    CustomerPendingSendAck,
    CustomerRedeemApprovalReq,
    CustomerRedeemReq,
    CustomerReject,
    CustomerSCPAck,
    CustomerSCPApprovalAck,
    CustomerSCPApprovalRej,
    CustomerSCPApprovalReq,
    CustomerSCPPendingAck,
    CustomerSCPPendingReviewAck,
    CustomerSCPRej,
    CustomerSCPReq,
    CustomerSCPReviewAck,
    CustomerSCPReviewRej,
    CustomerSCPReviewReq,
    CustomerSendApprovalReq,
    CustomerSendReq,
    DINAPIClientCreditRiskSetupReject,
    DINAPIClientLiquiditySetupReject,
    FirmRecord,
    FirmStatisticsReport,
    FirmWireDataRecord,
    HistoryAck,
    HistoryRej,
    HistoryRequest,
    IBNBankTransactionLimitRecord,
    IBNConnectionStatus,
    IBNTransactionLimitRecord,
    NetworkExposureLimitRecord,
    NetworkLiquidityLimitRecord,
    PCGUser,
    PrivateClientGroup,
    RecipientWireBlacklistOperationAck,
    RecipientWireBlacklistOperationRej,
    RecipientWireBlacklistOperationReq,
    RecipientWireBlacklistRecord,
    RequestForPaymentExpireTime,
    SCPContainerOption,
    SCPContainerRecord,
    SCPContainerType,
    SCPExecutionTime,
    SCPFrequencyType,
    SCPOperationType,
    SettlementCycleStatus,
    SettlementInstruction,
    SmartContractExecuteTime,
    SmartContractPayment,
    SmartContractPaymentType,
    SmartContractStatus,
    StatisticsReport,
    SystemKillSwitch,
    SystemSCPKillSwitch,
    SystemWireKillSwitch,
    TotalTokenBalance,
    Transaction,
    UserAccountRecord,
    UserRecord,
    UserRole,
    UserValidationRecord,
    UserValidationStats,
    WireRole,
    WireTransaction,
    WireTransactionRej
};

export {
    DefaultAbaBicOperationAck,
    DefaultAbaBicOperationRej,
    DefaultAbaBicOperationReq,
    DefaultAbaBicRecord,
    DefaultAbaFedOperationAck,
    DefaultAbaFedOperationRej,
    DefaultAbaFedOperationReq,
    DefaultAbaFedRecord,
    DefaultAccountRecord,
    DefaultAccountStatisticsReport,
    DefaultAccountWireDataRecord,
    DefaultActivity,
    DefaultAddressBookRecord,
    DefaultAdminDepositExceptionReq,
    DefaultAdminExtRecvExceptionReq,
    DefaultAdminExtSendExceptionReq,
    DefaultAdminRedeemExceptionReq,
    DefaultAlert,
    DefaultAPIAddConnectionReq,
    DefaultAPIAddFirmConnectionReq,
    DefaultAPIAddUserConnectionReq,
    DefaultAPIAdminAddConnectionRequest,
    DefaultAPIAdminAddUserConnectionRequest,
    DefaultAPIAdminDeleteApprovedAbaRequest,
    DefaultAPIAdminDeleteBicAbaRequest,
    DefaultAPIAdminDeleteConnectionRequest,
    DefaultAPIAdminDeleteUserConnectionRequest,
    DefaultAPIAdminDeleteUserRequest,
    DefaultAPIAdminModifyApprovedAbaRequest,
    DefaultAPIAdminModifyBicAbaRequest,
    DefaultAPIAdminModifyConnectionRequest,
    DefaultAPIAdminModifyFirmConnectionRequest,
    DefaultAPIAdminModifyFirmWireDataRequest,
    DefaultAPIAdminModifyUserConnectionRequest,
    DefaultAPIConnectionFirmsRecord,
    DefaultAPIConnectionRecord,
    DefaultAPIConnectionUsersRecord,
    DefaultAPIDeleteConnectionReq,
    DefaultAPIDeleteFirmConnectionReq,
    DefaultAPIDeleteUserConnectionReq,
    DefaultAPIModifyConnectionReq,
    DefaultAPIModifyFirmConnectionReq,
    DefaultAPIModifyUserConnectionReq,
    DefaultAPITransaction,
    DefaultBank2BankCreditProfile,
    DefaultBank2NetworkCreditProfile,
    DefaultBankAPIAccountInquiryAck,
    DefaultBankAPIAccountInquiryRej,
    DefaultBankAPIAccountInquiryReq,
    DefaultBankCreditRiskLimitAck,
    DefaultBankCreditRiskLimitRej,
    DefaultBankCreditRiskLimitReq,
    DefaultBankExposureLimitRecord,
    DefaultBankLiquidityLimitRecord,
    DefaultClientMessageRecord,
    DefaultClientMessageReq,
    DefaultClientRole,
    DefaultContainerStatus,
    DefaultCounterPartyRiskLimitRecord,
    DefaultCurrency,
    DefaultCustomerAddAccountReq,
    DefaultCustomerAddAccountWireDataReq,
    DefaultCustomerAddAddressBookRecordReq,
    DefaultCustomerAddFirmAccountReq,
    DefaultCustomerAddFirmReq,
    DefaultCustomerAddFirmWireDataReq,
    DefaultCustomerAddPCGReq,
    DefaultCustomerAddPCGUserReq,
    DefaultCustomerAddUserAccountReq,
    DefaultCustomerAddUserReq,
    DefaultCustomerAddUserRoleReq,
    DefaultCustomerAddUserValidationReq,
    DefaultCustomerAddWireAck,
    DefaultCustomerAddWireRej,
    DefaultCustomerAddWireReq,
    DefaultCustomerApprovalReq,
    DefaultCustomerApproveUserValidationReq,
    DefaultCustomerCounterPartyRiskLimitAck,
    DefaultCustomerCounterPartyRiskLimitRej,
    DefaultCustomerCounterPartyRiskLimitReq,
    DefaultCustomerDeleteAccountWireDataReq,
    DefaultCustomerDeleteAddressBookRecordReq,
    DefaultCustomerDeleteFirmReq,
    DefaultCustomerDeleteFirmWireDataReq,
    DefaultCustomerDeletePCGReq,
    DefaultCustomerDeletePCGUserReq,
    DefaultCustomerDeleteUserAccountReq,
    DefaultCustomerDeleteUserReq,
    DefaultCustomerDeleteUserRoleReq,
    DefaultCustomerDeleteUserValidationReq,
    DefaultCustomerDepositApprovalReq,
    DefaultCustomerDepositReq,
    DefaultCustomerExternalSendApprovalReq,
    DefaultCustomerExtSendReq,
    DefaultCustomerHeartbeat,
    DefaultCustomerIBNBankTransactionLimitAck,
    DefaultCustomerIBNBankTransactionLimitRej,
    DefaultCustomerIBNBankTransactionLimitReq,
    DefaultCustomerLiquidityLimitAck,
    DefaultCustomerLiquidityLimitRej,
    DefaultCustomerLiquidityLimitReq,
    DefaultCustomerLogin,
    DefaultCustomerLogout,
    DefaultCustomerModifyAccountReq,
    DefaultCustomerModifyAccountWireDataReq,
    DefaultCustomerModifyAddressBookRecordReq,
    DefaultCustomerModifyFirmAccountReq,
    DefaultCustomerModifyFirmReq,
    DefaultCustomerModifyFirmWireDataReq,
    DefaultCustomerModifyPCGReq,
    DefaultCustomerModifySettlementAck,
    DefaultCustomerModifySettlementRej,
    DefaultCustomerModifySettlementReq,
    DefaultCustomerModifyUserAccountReq,
    DefaultCustomerModifyUserReq,
    DefaultCustomerModifyUserRoleReq,
    DefaultCustomerModifyUserValidationReq,
    DefaultCustomerPendingDepositAck,
    DefaultCustomerPendingExtSendAck,
    DefaultCustomerPendingRedeemAck,
    DefaultCustomerPendingSendAck,
    DefaultCustomerRedeemApprovalReq,
    DefaultCustomerRedeemReq,
    DefaultCustomerReject,
    DefaultCustomerSCPAck,
    DefaultCustomerSCPApprovalAck,
    DefaultCustomerSCPApprovalRej,
    DefaultCustomerSCPApprovalReq,
    DefaultCustomerSCPPendingAck,
    DefaultCustomerSCPPendingReviewAck,
    DefaultCustomerSCPRej,
    DefaultCustomerSCPReq,
    DefaultCustomerSCPReviewAck,
    DefaultCustomerSCPReviewRej,
    DefaultCustomerSCPReviewReq,
    DefaultCustomerSendApprovalReq,
    DefaultCustomerSendReq,
    DefaultDINAPIClientCreditRiskSetupReject,
    DefaultDINAPIClientLiquiditySetupReject,
    DefaultFirmRecord,
    DefaultFirmStatisticsReport,
    DefaultFirmWireDataRecord,
    DefaultHistoryAck,
    DefaultHistoryRej,
    DefaultHistoryRequest,
    DefaultIBNBankTransactionLimitRecord,
    DefaultIBNConnectionStatus,
    DefaultIBNTransactionLimitRecord,
    DefaultNetworkExposureLimitRecord,
    DefaultNetworkLiquidityLimitRecord,
    DefaultPCGUser,
    DefaultPrivateClientGroup,
    DefaultRecipientWireBlacklistOperationAck,
    DefaultRecipientWireBlacklistOperationRej,
    DefaultRecipientWireBlacklistOperationReq,
    DefaultRecipientWireBlacklistRecord,
    DefaultRequestForPaymentExpireTime,
    DefaultSCPContainerOption,
    DefaultSCPContainerRecord,
    DefaultSCPContainerType,
    DefaultSCPExecutionTime,
    DefaultSCPFrequencyType,
    DefaultSCPOperationType,
    DefaultSettlementCycleStatus,
    DefaultSettlementInstruction,
    DefaultSmartContractExecuteTime,
    DefaultSmartContractPayment,
    DefaultSmartContractPaymentType,
    DefaultSmartContractStatus,
    DefaultStatisticsReport,
    DefaultSystemKillSwitch,
    DefaultSystemSCPKillSwitch,
    DefaultSystemWireKillSwitch,
    DefaultTotalTokenBalance,
    DefaultTransaction,
    DefaultUserAccountRecord,
    DefaultUserRecord,
    DefaultUserRole,
    DefaultUserValidationRecord,
    DefaultUserValidationStats,
    DefaultWireRole,
    DefaultWireTransaction,
    DefaultWireTransactionRej
};

export default CoreMsg;